import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/PowerOff';
// import { makeStyles } from '@mui/styles';

import { constants } from '../../Constants/constants'
import { post, put } from '../../helper/baseFetch'
import { getOne } from '../../helper/baseFetch'
import { setSurveyMapping, setSurveyMappingValue } from '../../actions/surveyMappingAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { getContent } from '../../Component/EditCreateDisplay/EditUtil'
import { ProfileCodeSection } from '../Staff/StaffProfileCodeSection'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { SurveyListWithDrawer } from './SurveyListWithDrawer'
import SurveyMappingValidation from '../../validations/surveyMappingValidation'
import { helperTextStyles } from '../../helper/util'
import { surveyMappingValidationConstants } from '../../Constants/validationConstants'

const resource = 'survey'

export const SurveyMappingCreate = () => {

  const dispatch = useDispatch()
  const store = useStore()
  const params = useParams()
  const history = useHistory()

  const savedSurveyMapping = useSelector((state) => state.surveyMapping.ui.surveyMapping)
  const helperTextStylesClasses = helperTextStyles()

  const [showQueueTransferProfileCode, setShowQueueTransferProfileCode] = useState(false)
  const [ready, setReady] = useState(false)
  const [clear, setClear] = useState(true)
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })

  const [, setErrorVersion] = useState(SurveyMappingValidation.getVersion())

  const tabs = [
    {
      label: { resource: resource, key: 'info' },
      tabIndex: constants.RESTAURANT_SURVEY_SUB_TUB.SURVEY_MAPPING_LIST,
    },
  ]

  const tempMerchantUserEditList = [
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'refCode' },
      value: savedSurveyMapping.refCode,
      variant: constants.STYLE.VARIANT.STANDARD,
      disabled: true,
      name: 'refCode',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'surveyId' },
      type: constants.TYPE.FUNCTION,
      value: (
        <SurveyListWithDrawer
          resource={resource}
          resourceKey={'surveyId'}
          value={savedSurveyMapping.surveyId}
          onChangeInput={onChangeInput}
          restUrlId={params.restUrlId}
          helperText={SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_SURVEY_ID}`)}
        />
      ),
      variant: constants.STYLE.VARIANT.STANDARD,
      name: 'surveyId',
      isEndOfLine: true,
    },
    // {
    //   className: 'edit-create-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'refType' },
    //   type: constants.TYPE.FUNCTION,
    //   value: (
    //     <TempAutoSelectInput
    //       inputSetting={{
    //         label: { resource: resource, key: 'refType' },
    //         value: savedSurveyMapping.refType,
    //         selectValue: constants.CHOICES.SURVEY.REF_TYPE,
    //         name: 'refType',
    //         disableClearable: true,
    //         helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_REF_TYPE}`),
    //       }}
    //       handleChange={onChangeInput}
    //     />
    //   ),
    //   isEndOfLine: false,
    // },
    {
      className: 'edit-create-input',
      variant: constants.STYLE.VARIANT.STANDARD,
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'serviceType' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'serviceType' },
            value: savedSurveyMapping.serviceType,
            selectValue: constants.CHOICES.SURVEY.SERVICE_TYPE,
            name: 'serviceType',
            disableClearable: true,
            helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_SERVICE_TYPE}`),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'surveyType' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'surveyType' },
            value: savedSurveyMapping.surveyType,
            selectValue: constants.CHOICES.SURVEY.SURVEY_TYPE,
            name: 'surveyType',
            disableClearable: true,
            helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_SURVEY_TYPE}`),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      variant: constants.STYLE.VARIANT.STANDARD,
      label: { resource: resource, key: 'mandatory' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'mandatory' },
            value: savedSurveyMapping.mandatory,
            selectValue: constants.CHOICES.SURVEY.MANDATORY,
            name: 'mandatory',
            disableClearable: true,
            helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_MANDATORY}`),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'startTimestamp' },
      type: constants.TYPE.DATETIME_LOCAL,
      value: savedSurveyMapping.startTimestamp,
      name: 'startTimestamp',
      isEndOfLine: false,
      helperTextIcon: true,
      helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_START_TIME}`),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'endTimestamp' },
      type: constants.TYPE.DATETIME_LOCAL,
      value: savedSurveyMapping.endTimestamp,
      name: 'endTimestamp',
      isEndOfLine: false,
      helperTextIcon: true,
      helperText: SurveyMappingValidation.getErrorMessages(`${surveyMappingValidationConstants.KEY_END_TIME}`),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    }
  ]

  const content = [
    {
      tab: tempMerchantUserEditList.map((inputSetting, index) => {
        let content = getContent(inputSetting, index, onChangeInput)
        return (
          <div className="edit-display-wrapper" key={index}>
            {content}
            {inputSetting.isEndOfLine && <div></div>}
          </div>
        )
      }),
      btn: true,
    }
  ]

  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'save' },
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    // {
    //   variant: constants.STYLE.VARIANT.CONTAINED,
    //   color: constants.STYLE.PRIMARY,
    //   label: { key: 'clear' },
    //   disabled: false,
    //   onClick: onClickClear,
    //   className: 'margin-left-16',
    //   icon: <ClearIcon />,
    // },
  ]

  const onClickBackToEdit = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    onClickClear()
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push(
      '/' +
      constants.PATH.SHOP.SYSTEM_GROUP_RESTAURANT +
      '/' +
      params.restUrlId +
      '/' +
      constants.RESTAURANT_TAB.SURVEY +
      '/' +
      constants.RESTAURANT_SURVEY_SUB_TUB.SURVEY_MAPPING_LIST
    )
  }

  function onChangeInput(name, e) {
    switch (name) {
      case 'startTimestamp':
      case 'endTimestamp':
        dispatch(setSurveyMappingValue(name, savedSurveyMapping, '', new Date(e).getTime()))
        break
      default:
        dispatch(setSurveyMappingValue(name, savedSurveyMapping, '', e))
    }
  }

  function onClickSave() {
    SurveyMappingValidation.validateSavedData(savedSurveyMapping, true)
    if (SurveyMappingValidation.isValid()) {
      post(
        constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP,
        savedSurveyMapping,
        () => {
          setDialog({
            open: true,
            onClose: onClickBackToEdit,
            dialogContentText: { key: 'createSuccess' },
            dialogActions: [
              // { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
              { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
            ],
          })
          setClear(false)
        },
        undefined,
        store
      )
    } else {
      setErrorVersion(SurveyMappingValidation.getVersion())
    }
  }

  function onClickClear() {
    setClear(true)
  }

  useEffect(() => {
    if (clear === true) {
      dispatch(setSurveyMappingValue('refCode', {}, '', params.restUrlId))
      setReady(true)
    }
  }, [clear]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <EditCreateDisplay
        code={savedSurveyMapping && savedSurveyMapping.id ? savedSurveyMapping.id : ''}
        resource={resource}
        tabs={tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        display="create"
      />
      {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
    </>
  )
}
